let i = 0;

function generateEventKey() {
    return `accEv${i++}`;
}

const events = {
    // Emitted on $rootScope whenever a user logs in or logs out.
    // Event data: authenticated (boolean).
    authChange: generateEventKey()

    // // Emitted on <scope> whenever <event>.
    // // Event data: <arguments>
    // eventName: generateEventKey()
};

export default events;



// WEBPACK FOOTER //
// ./data/constants/events.js